// namespace

// actions

// mutations
export const SET_CURSOR_X = 'SET_CURSOR_X'
export const SET_SUPER_ADMIN = 'SET_SUPER_ADMIN'

// getters
